import { Icon } from './Icon.js';

export function ErrorNote(props: { message: string }) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-rose-200 bg-rose-50 dark:bg-rose-950/40 px-4 py-3 text-sm text-rose-800 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-200">
      <Icon name="alert" className="mt-0.5 size-4 shrink-0" />
      <span>{props.message}</span>
    </div>
  );
}
